import { styled } from "@mui/material/styles";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";
import { useStyles } from "../../common/appStyles";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#10366E",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
  },
}));

const StyledTableCellReport = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#10366E",
    color: theme.palette.common.white,
    padding: "6px 6px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 9,
    padding: "6px 1px",
  },
}));

export default function TableComponent({
  results,
  firstColumnTitle,
  columnTitles,
  pagination,
  noPadding,
  fixedSizeInPx,
  greaterLetterSize,
  whiteSpaceValue,
  reportSize,
  notNumbered,
  customHeight,
}) {
  const classes = useStyles();

  return (
    <div
      className={`flex justify-center items-center overflow-x-auto flex-col ${
        noPadding ? "" : "lateral_padding"
      }`}
    >
      <div
        className=" w-full p-1"
        style={
          customHeight
            ? { height: customHeight }
            : fixedSizeInPx
            ? { height: `${fixedSizeInPx}px` }
            : {}
        }
      >
        <TableContainer component={Paper} sx={{ borderRadius: "4px" }}>
          <Table stickyHeader size="small">
            <TableHead sx={{ whiteSpace: whiteSpaceValue ?? "nowrap" }}>
              <StyledTableRow key={0}>
                {!notNumbered &&
                  (reportSize ? (
                    <StyledTableCellReport
                      key={`title-cell-${Math.random()}`}
                      className={
                        reportSize
                          ? classes.tableHeaderReport
                          : classes.tableHeader
                      }
                    >
                      {"#"}
                    </StyledTableCellReport>
                  ) : (
                    <StyledTableCellReport
                      key={`title-cell-${Math.random()}`}
                      className={
                        reportSize
                          ? classes.tableHeaderReport
                          : classes.tableHeader
                      }
                    >
                      {"#"}
                    </StyledTableCellReport>
                  ))}

                {firstColumnTitle &&
                  (reportSize ? (
                    <StyledTableCell
                      key={`title-cell-${Math.random()}`}
                      className={
                        reportSize
                          ? classes.tableHeaderReport
                          : classes.tableHeader
                      }
                    >
                      {firstColumnTitle}
                    </StyledTableCell>
                  ) : (
                    <StyledTableCellReport
                      key={`title-cell-${Math.random()}`}
                      className={
                        reportSize
                          ? classes.tableHeaderReport
                          : classes.tableHeader
                      }
                    >
                      {firstColumnTitle}
                    </StyledTableCellReport>
                  ))}
                {columnTitles.map((title) =>
                  reportSize ? (
                    <StyledTableCell
                      key={`${title}-${Math.random()}`}
                      className={
                        reportSize
                          ? classes.tableHeaderReport
                          : classes.tableHeader
                      }
                    >
                      {title}
                    </StyledTableCell>
                  ) : (
                    <StyledTableCell
                      key={`${title}-${Math.random()}`}
                      className={
                        reportSize
                          ? classes.tableHeaderReport
                          : classes.tableHeader
                      }
                    >
                      {title}
                    </StyledTableCell>
                  )
                )}
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {results?.map((row, index) => (
                <StyledTableRow key={row.key}>
                  {!notNumbered &&
                    (reportSize ? (
                      <StyledTableCellReport
                        key={`${row.key}-cell-${Math.random()}`}
                        className={
                          greaterLetterSize
                            ? classes.tableRowLarger
                            : classes.tableRow
                        }
                        sx={{
                          whiteSpace: whiteSpaceValue ?? "nowrap",
                          width: "30px",
                        }}
                      >
                        {index + 1}
                      </StyledTableCellReport>
                    ) : (
                      <StyledTableCell
                        key={`title-cell-${Math.random()}`}
                        className={
                          reportSize ? classes.tableRowLarger : classes.tableRow
                        }
                        sx={{ width: "30px" }}
                      >
                        {index + 1}
                      </StyledTableCell>
                    ))}

                  {row.data.map((data) =>
                    reportSize ? (
                      <StyledTableCellReport
                        key={`${row.key}-cell-${Math.random()}`}
                        className={
                          greaterLetterSize
                            ? classes.tableRowLarger
                            : classes.tableRow
                        }
                        sx={{
                          whiteSpace: whiteSpaceValue ?? "nowrap",
                        }}
                      >
                        {data}
                      </StyledTableCellReport>
                    ) : (
                      <StyledTableCell
                        key={`${row.key}-cell-${Math.random()}`}
                        className={
                          greaterLetterSize
                            ? classes.tableRowLarger
                            : classes.tableRow
                        }
                        sx={{
                          whiteSpace: whiteSpaceValue ?? "nowrap",
                        }}
                      >
                        {data}
                      </StyledTableCell>
                    )
                  )}
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      {pagination}
    </div>
  );
}
